import React, { ButtonHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'
import { Link } from 'react-router-dom'
import { getThemeColor } from 'app/styles/utils'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  // Use to props for internal link, or href for external link
  to?: string
  href?: string
  target?: string
  rel?: string
  variant?: ButtonVariant
  size?: ButtonSize
  shadow?: boolean
}

export type ButtonSize = 'lg' | 'normal'
export type ButtonVariant = 'grigio' | 'nero' | 'ciano' | 'trasparente'

interface ButtonProps {
  variant?: ButtonVariant
  size?: string
  shadow?: boolean
}

const getButtonVariant = ({ variant }: ButtonProps) => {
  switch (variant) {
    case 'grigio':
      return css`
        color: ${themeEstra.color.primari.grigioEstra};
        background-color: ${themeEstra.color.neutri.grigioBg};
      `

    case 'ciano':
      return css`
        color: #fff;
        background-color: ${themeEstra.color.primari.ciano};
      `

    case 'trasparente':
      return css`
        color: ${themeEstra.color.neutri.grigio};
        background-color: transparent;
      `

    default:
      return css`
        color: #fff;
        background: ${getThemeColor(variant) ||
          themeEstra.color.primari.neroEstra};
      `
  }
}

const getSizeVariant = ({ size }: ButtonProps) => {
  switch (size) {
    case 'lg':
      return css`
        padding: 0 2rem;
        line-height: 50px;
        height: 50px;
        @media (min-width: ${themeEstra.bp.tablet}) {
          padding: 0 2.75rem;
        }
      `

    default:
      return css`
        line-height: 40px;
        height: 40px;
        padding: 0 1.6rem;
      `
  }
}

export const Button: React.FC<Props> = ({
  children,
  target,
  variant,
  to,
  rel,
  href,
  size,
  shadow,
  onClick,
  disabled,
  className,
  type,
}) => {
  return (
    <Wrapper
      as={to ? (Link as Fixme) : href ? 'a' : undefined}
      to={to}
      target={target}
      rel={rel}
      href={href}
      variant={variant}
      size={size}
      shadow={shadow}
      onClick={onClick}
      disabled={disabled}
      className={className}
      type={type}
    >
      {children}
    </Wrapper>
  )
}

const Wrapper = styled.button.attrs((props: ButtonProps) => ({
  variant: props.variant,
  size: props.size,
}))<ButtonProps>`
  font-family: inherit;
  font-size: inherit;
  font-weight: bold;
  letter-spacing: 0.02em;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  border-radius: 10rem;
  border: 0;
  outline: 0;
  box-shadow: ${({ shadow }) =>
    shadow ? '0px 2px 10px rgba(165, 170, 178, 0.6);' : ''};
  cursor: pointer;
  overflow: hidden;
  :hover {
    opacity: 0.8;
  }

  ${getButtonVariant};

  ${getSizeVariant};

  &:disabled {
    pointer-events: none;
    touch-action: none;
    opacity: 0.8;
  }

  img {
    vertical-align: middle;
    margin-right: 0.5rem;
  }
`
